import React, { useEffect, useState } from "react";
import { motion, useSpring, useTransform } from "framer-motion";

export function AnimatedNumber({ value, decimals = 0, className = "" }) {
  const spring = useSpring(0, { stiffness: 60, damping: 18 });
  const display = useTransform(spring, (v) => v.toFixed(decimals).replace(".", decimals ? "," : "."));
  useEffect(() => { spring.set(value); }, [value, spring]);
  return <motion.span className={className}>{display}</motion.span>;
}

// Animated circular score ring
export function ScoreRing({ value, size = 180, stroke = 14, label = "" }) {
  const [prog, setProg] = useState(0);
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  useEffect(() => {
    const t = setTimeout(() => setProg(value), 200);
    return () => clearTimeout(t);
  }, [value]);
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }} data-testid="score-ring">
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id="ringGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#00E5FF" />
            <stop offset="100%" stopColor="#6366F1" />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.07)" strokeWidth={stroke} fill="none" />
        <motion.circle
          cx={size / 2} cy={size / 2} r={r} stroke="url(#ringGrad)" strokeWidth={stroke} fill="none"
          strokeLinecap="round" strokeDasharray={c}
          initial={{ strokeDashoffset: c }}
          animate={{ strokeDashoffset: c - (prog / 100) * c }}
          transition={{ duration: 1.6, ease: "easeOut" }}
          style={{ filter: "drop-shadow(0 0 6px rgba(99,102,241,0.6))" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-display font-black leading-none" style={{ fontSize: size * 0.28 }}>
          <AnimatedNumber value={value} />
        </span>
        <span className="text-[hsl(var(--muted-foreground))] text-xs mt-1">{label || "/ 100"}</span>
      </div>
    </div>
  );
}
